import * as React from 'react';
import { Label, TrustpilotSpinner, ProgressBar } from '../CommonUI';
import { FailedOrders as FailedOrdersModel, PastOrdersInfo, PastOrdersPeriod, Settings } from '../Model';
import { Flex, Box } from '../CommonUI/Layout';
import { Text } from 'ilenia';
import { FailedOrders, InitialSync } from '../Components';

interface PastOrderProps {
    source: string;
    period?: PastOrdersPeriod;
    syncedOrders: number;
    unsyncedOrders: number;
    failedOrders: FailedOrdersModel[];
    showInitial?: boolean;
    syncInProgress?: boolean;
    totalOrders?: number;
    sendPostMessage: (message: string | object) => void;
    onChange?: (settings: PastOrdersInfo) => void;
    tierName: string;
    integrationKey: string;
    onLoggedInChange: (toggle: boolean) => void;
    onConsentChange: (toggle: boolean) => void;
    onToggleSettingsSave: (value: boolean) => void;
    onSettingsSave: () => void;
    onProductReviewsSettingChange: (selector: Settings) => void;
    settings: Settings;
}

interface PastOrderState {
    notification: boolean;
}

export class PastOrders extends React.Component<PastOrderProps, PastOrderState> {
    public interval: NodeJS.Timer | null;

    constructor(props: PastOrderProps) {
        super(props);
        this.onSync = this.onSync.bind(this);
        this.onResync = this.onResync.bind(this);
        this.onPeriodChange = this.onPeriodChange.bind(this);
        this.onNotificationClose = this.onNotificationClose.bind(this);
        this.state = { notification: false };
    }

    public componentDidMount() {
        const { syncInProgress, sendPostMessage } = this.props;
        if (syncInProgress) {
            this.interval = setInterval(() => sendPostMessage(`issynced`), 3000);
        }
        analytics.page();
    }

    public componentWillReceiveProps(nextProps: PastOrderProps) {
        const { syncInProgress, sendPostMessage } = nextProps;
        if (syncInProgress && !this.interval) {
            this.interval = setInterval(() => sendPostMessage(`issynced`), 3000);
        } else if (!syncInProgress && this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    public componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    public onSync(period: PastOrdersPeriod) {
        this.props.onChange!({ showInitial: false, syncInProgress: true });
        this.props.sendPostMessage(`sync:${period}`);
        this.setState({ notification: true });
    }

    public onPeriodChange(period: PastOrdersPeriod) {
        this.props.sendPostMessage({showTotalOrders: period});
    }

    public onResync() {
        this.props.onChange!({ syncInProgress: true, synced: 0, unsynced: 0 });
        this.props.sendPostMessage(`resync:`);
    }

    public onNotificationClose() {
        this.setState({ notification: false });
    }

    public showProgress(syncedOrders: number, unsyncedOrders: number, totalOrders: number) {
        return (
            <Flex>
                <Label label="pastOrders.syncInProgressTitle2"/>
                <Box mt={14} mb={14} width={'auto'}>
                    <span style={{ color: '#00b67a' }}>{syncedOrders + unsyncedOrders}</span> {`out of ${totalOrders}`}
                </Box>
                <Box mt={14} mb={14} width={'auto'}>
                    <ProgressBar percentage={Math.round(((syncedOrders + unsyncedOrders) / totalOrders) * 100)} />
                </Box>
                <p><Text id="pastOrders.syncInProgressDesc2"/></p>
            </Flex>
        );
    }

    public showSpinner() {
        return (
            <Flex>
                <Label label="pastOrders.syncInProgressTitle"/>
                <p><Text id="pastOrders.syncInProgressDesc"/></p>
                <Box mt={14} mb={14} width={'auto'}>
                    <TrustpilotSpinner active={true}/>
                </Box>
            </Flex>
        );
    }

    public syncInProgress() {
        const { syncedOrders, unsyncedOrders, totalOrders } = this.props;
        return (
            <Flex>
                {totalOrders !== undefined ? this.showProgress(syncedOrders, unsyncedOrders, totalOrders) : this.showSpinner()}
            </Flex>
        );
    }

    public render() {
        const { syncInProgress, showInitial, syncedOrders, unsyncedOrders, failedOrders, source, totalOrders, tierName, integrationKey, settings } = this.props;
        const { notification } = this.state;
        return (
            <Box pb={30}>
                {showInitial
                    ? <InitialSync
                        onSync={this.onSync}
                        onShowTotalOrders={this.onPeriodChange}
                        source={source}
                        totalOrders={totalOrders}
                        tierName={tierName}
                        integrationKey={integrationKey}
                        onProductReviewsSettingChange={this.props.onProductReviewsSettingChange}
                        onConsentChange={this.props.onConsentChange}
                        onToggleSettingsSave={this.props.onToggleSettingsSave}
                        settings={settings}
                        onLoggedInChange={this.props.onLoggedInChange}
                        onSettingsSave={this.props.onSettingsSave}
                    />
                    : syncInProgress
                        ? this.syncInProgress()
                        : <FailedOrders
                            syncedOrders={syncedOrders}
                            unsyncedOrders={unsyncedOrders}
                            failedOrders={failedOrders}
                            onChange={this.onResync}
                            source={source}
                            notification={notification}
                            onNotificationClose={this.onNotificationClose}
                            tierName={tierName}
                        />
                }
            </Box>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/PastOrders.tsx